import { AccordionItem } from "components/AccordionItem";
import { CardStatus } from "components/CardStatus/CardStatus";
import { Link } from "components/Link";
import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";
import { calculateRems } from "styles/mixins/calculateRem";
import type { ElearningThemeInterface } from "themes/elearningInterface.theme";

interface Props {
  theme: ElearningThemeInterface;
}

export const StyledDiagnosticTestGroupItem = styled(Link)<Props>`
  width: 100%;
`;
export const StyledAccordionDiagnosticListItem = styled(AccordionItem)<Props>`
  .tab-label::before {
    content: none;
  }
`;

export const StyledPanelRightHeader = styled.div<Props>`
  display: flex;
  align-items: center;
  width: 18rem;
  justify-content: flex-end;
`;

export const StyledDiagnosticTestGroupCard = styled(CardStatus)<ThemeProps>`
  height: fit-content;
  min-height: 6rem;
  column-gap: 1rem;
  grid-template-columns: 4fr 1fr 1fr;
  background-color: ${(props: ThemeProps) => props.theme.palette.neutral.white};

  button {
    width: 9rem;
    padding: ${calculateRems([11.2, 8])};
    font-size: ${(props: ThemeProps) => props.theme.font.size._14};
    font-weight: ${(props: ThemeProps) => props.theme.font.weight.bold};
  }`;
